import { render, staticRenderFns } from "./derive.vue?vue&type=template&id=38d3e58f"
import script from "./derive.vue?vue&type=script&lang=js"
export * from "./derive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports